import TrackerModel from 'models/tracker';


export default TrackerModel.extend({
  urlRoot: API_PREFIX + window.Urls['accounts_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'account-profile',
  }),

  days_since_joined: function () {
    var joined = new Date(this.get('user__date_joined'));
    return Math.max(0, Math.floor((new Date() - joined) / 86400000));
  }
});



// WEBPACK FOOTER //
// ./static/js/models/account_profile.js